import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MemberPlotsListComponent } from './member-plots-list/member-plots-list.component';



@NgModule({
  declarations: [
    MemberPlotsListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class MemberPlotsModule { }
